// src/RiskMonitors.js
import React from 'react';
import { Grid, Card, CardContent, Typography, Divider, Box } from '@mui/material';
import StageMonitor from './StageMonitor';
//import RiskCardMonitor from './RiskCardMonitor';
import ScenarioAnalyzer from './NarrativeScenarioAnalyzer';

const SectionDivider = () => (
  <Divider sx={{ my: 1, borderColor: 'divider', opacity: 0.5 }} />
);

export default function RiskMonitors({ modelId }) {
  return (
    
    <Grid container spacing={3}>
    {/* Stage Monitor Card */}
    <Grid item xs={12} sm={6}>
      <Card sx={cardSx}>
        <CardContent>
          <Typography variant="h6">Model Lifecycle Analyzer</Typography>
          <SectionDivider />
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Review and update model risks and action plans based on model progress across the model lifecycle
          </Typography>
          <Box mt={2}>
            <StageMonitor modelId={modelId} />
          </Box>
        </CardContent>
      </Card>
    </Grid>

    {/* Scenario Analyzer Card */}
    <Grid item xs={12} sm={6}>
      <Card sx={cardSx}>
        <CardContent>
          <Typography variant="h6">Use Case Scenario Analyzer</Typography>
          <SectionDivider />
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Inspects how changes to the use case, business and model context affects current risks and action plans
          </Typography>
          <Box mt={2}>
            <ScenarioAnalyzer modelId={modelId} />
          </Box>
        </CardContent>
      </Card>
    </Grid>

      {/* Bias Monitor */}
      <Grid item xs={12} sm={6}>
      <Card sx={cardSx}>
           
          <CardContent>
            <Typography variant="h6" color="text.primary">
              Bias Monitor
            </Typography>
            <SectionDivider />
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Monitor model fairness and bias and their impact on risks
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 4, fontStyle: 'italic' }}>
            coming soon
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      {/* Compliance Monitor */}
      <Grid item xs={12} sm={6}>
      <Card sx={cardSx}>
         
          <CardContent>
            <Typography variant="h6" color="text.primary">
              Compliance Monitor
            </Typography>
            <SectionDivider />
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Monitor compliance frameworks change and measure effect on compliance risks
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 4, fontStyle: 'italic' }}>
              Coming soon
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
const cardSx = {
  height: '100%',
  cursor: 'default',
  transition: 'all 0.2s ease-in-out',
  borderRadius: 2,
  border: '1px solid',
  borderColor: 'divider',
  bgcolor: 'background.default',
  boxShadow: 'none',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 12px rgba(0,0,0,0.04)',
    borderColor: 'primary.light',
  },
};